import styled from 'styled-components';
import JSONTree from 'core/jsonTree';

export const StyledJSONTree = styled(JSONTree)`
  &&&&&&&& .react-json-view {
    /** conversion from a .css file */
    background-color: transparent;
  }
`;

export const Cell = styled.div`
  height: 100%;
`;

export const ToolbarContainer = styled.div<{ $hasHeaderContent: boolean }>`
  align-items: center;
  display: flex;
  justify-content: ${({ $hasHeaderContent }) => ($hasHeaderContent ? 'space-between' : 'flex-end')};
`;

export const TableContainer = styled.div`
  .preview-results-table-view {
    /** conversion from a .css file */
    width: 100%;
  }
`;
